// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".verify-container .content[data-v-3344506d] {\n  margin: 100px auto 50px;\n  text-align: center;\n  font-size: 30px;\n}\n.verify-container .content .icon[data-v-3344506d] {\n  font-size: 60px;\n  color: #5ea53b;\n  margin-bottom: 20px;\n}\n.verify-container .active[data-v-3344506d] {\n  color: #5ea53b;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
